import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import type { FlattenSimpleInterpolation } from 'styled-components';
import { simpleMarkdownTransform } from '../../utils/transformers';
import { RichTextComponent } from './RichTextPartial.styles';
import { markdownComponents } from './markdownComponents/MarkdownComponents';

export type RichTextProps = {
  text: string;
  fontSize: FlattenSimpleInterpolation;
  className?: string;
  'data-testid'?: string;
};

const createCustomParagraph = (dataTestId?: string) =>
  function CustomParagraph({ node, ...props }: any) {
    return dataTestId ? <p {...props} data-testid={dataTestId} /> : <p {...props} />;
  };

export function RichTextPartial({ text, fontSize, className, 'data-testid': dataTestId }: RichTextProps) {
  const ParagraphComponent = createCustomParagraph(dataTestId);

  const customComponents = {
    ...markdownComponents,
    p: ParagraphComponent,
  };

  return (
    <RichTextComponent
      components={customComponents}
      rehypePlugins={[rehypeRaw]}
      remarkPlugins={[remarkGfm]}
      $fontSize={fontSize}
      className={className}
    >
      {simpleMarkdownTransform(text)}
    </RichTextComponent>
  );
}
